import { Card, CardContent, Grid, Typography } from '@mui/material';
import { FormControlLabel } from '@components/formControlLabel';
import { useStore } from '@store/GlobalStore';
import * as styles from '@pages/BindQuote/styles';
import { Checkbox } from '@components/checkbox/Checkbox';
import { TextField } from '@components/textField/TextField';
import { shallow } from 'zustand/shallow';
import { useQuoteStore } from '@store/Quote/QuoteStore';

export type BillingConditionsProps = {
  attributeTypes: Record<
    string,
    {
      key: string;
      options?: { value: string; label: string }[];
      label: string | null;
    }
  >;
};

export const BindingConditions = ({ attributeTypes }: BillingConditionsProps) => {
  const [{ isLioSales }] = useStore((state) => [state.userAuth], shallow);
  const [billingCardFields, setBillingCardFields] = useQuoteStore(
    (state) => [state.billingCardFields, state.setBillingCardFields],
    shallow,
  );

  const handleInputFieldChange = (attributeKey: string, value: string | boolean) => {
    const values = { ...billingCardFields, [attributeKey]: { ...billingCardFields[attributeKey], value } };
    setBillingCardFields(values);
  };
  return (
    <Card elevation={0} sx={{ ...styles.cardSx, backgroundColor: 'panel.light' }}>
      <CardContent>
        <Grid container>
          <Grid size={{ xs: 12 }}>
            <Typography
              variant='h6'
              sx={{
                display: 'block',
                marginBottom: '20px',
              }}
            >
              Binding Conditions
            </Typography>
          </Grid>
          <Grid
            container
            size={{ xs: 12, md: 11, lg: 9, xl: 7 }}
            sx={{
              flexDirection: 'row',
              justifyContent: 'space-between',
              marginBottom: '20px',
              width: '100%',
            }}
          >
            <Grid size={{ xs: 12 }}>
              <TextField
                multiline
                rows={4}
                inputLabel={attributeTypes.bindingConditionsDetails.label}
                value={billingCardFields.bindingConditionsDetails.value}
                onChangeInput={(value) => handleInputFieldChange(attributeTypes.bindingConditionsDetails.key, value)}
                fullWidth
                disabled={isLioSales}
                sx={{ marginBottom: '20px' }}
              />
            </Grid>
            <Grid size={{ xs: 12 }}>
              <FormControlLabel
                label='Binder'
                checked={billingCardFields.binderInd.value}
                control={
                  <Checkbox
                    data-testid='binderInd'
                    checked={billingCardFields.binderInd.value}
                    onChange={() => handleInputFieldChange('binderInd', !billingCardFields.binderInd.value)}
                  />
                }
              />
            </Grid>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};
